import React, { useState, useEffect } from "react";
import * as httpClient from "../../util/httpClient";
import { useDispatch, useSelector } from "react-redux";
import * as ForgotPasswordActions from "../../store/forgotPasswordService/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import { useForm } from "react-hook-form";
import { History } from "history";
import NeedHelp from "./NeedHelp";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const SecurityQuestionAnswer = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const [state, setState] = useState({ securityQuestion: [], isLoading: false, errorMessage: "", returnToLoginView: false });
    const dispatch = useDispatch();
    const submitSecurityQuestionAnswer = (securityQuestionAnswer: any, history: any) =>
        dispatch(ForgotPasswordActions.actionCreators.submitSecurityQuestionAnswer(securityQuestionAnswer, history));
    const email = useSelector((state: ApplicationState) => (state.forgotPasswordState && state.forgotPasswordState.email ? state.forgotPasswordState.email : ""));
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const requestSecurityQuestion = () => {
        setState({ ...state, isLoading: true });

        const requestBody = {
            email,
        };

        httpClient
            .sendRequest("POST", `web/forgot-password/get-security-questions`, requestBody)
            .then((data) => {
                setState({ ...state, isLoading: false });

                if (data && !data["hasError"]) {
                    if (data.partnerSiteRedirectionRequired) {
                        window.location.href = data.partnerURL;
                        return;
                    } else {
                        setState({ ...state, securityQuestion: data["userSecurityQuestion"] });
                        dispatch({ type: "SECURITY_QUE_NOT_AVAILABLE", isSecurityQueNotAvailable: false });
                    }
                }
                if (data && data["hasError"]) {
                    dispatch({ type: "SECURITY_QUE_NOT_AVAILABLE", isSecurityQueNotAvailable: true });
                    props.history.push("/forgot-password");
                }
            })
            .catch(function (error) {
                setState({ ...state, isLoading: false });
            });
    };
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const setLanguage = () => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                            .split(";")
                            .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                            .split("=")[1]
                            ? document.cookie
                                .split(";")
                                .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    };
    const submitAnswers = (securityQuestionAnswer: any, history: History) => {
        setState({ ...state, errorMessage: "", isLoading: true });

        const requestBody = {
            validateSecurityAnswer: securityQuestionAnswer,
        };

        httpClient
            .sendRequest("POST", `web/forgot-password/validate-security-questions`, requestBody)
            .then((data) => {
                if (data.responseMessage != null) {
                    if (securityQuestionAnswer.length > 1) {
                        setState({ ...state, errorMessage: tLang("securityQuestionAnswers.errorMessages.msg1"), isLoading: false });
                    } else {
                        setState({ ...state, errorMessage: tLang("securityQuestionAnswers.errorMessages.msg2"), isLoading: false });
                    }
                }

                if (data.redirectToLoginPage) {
                    setState({ ...state, returnToLoginView: true, isLoading: false });
                }

                if (data.isValidSecurityAnswer) {
                    setState({ ...state, isLoading: false });
                    submitSecurityQuestionAnswer(data, props.history);
                }
            })
            .catch(function (error) {
                setState({ ...state, isLoading: false });
            });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (email && email !== "") {
            requestSecurityQuestion();
        } else {
            props.history.push("/forgot-password");
        }
        setLanguage();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const onSubmit = (data: any) => {
        window.addToDataLayer({ event: "Submit Security Question Answer" });
        const securityQuestionAnswerList = prepareAnswerObject(data);
        submitAnswers(securityQuestionAnswerList, props.history);
    };

    const prepareAnswerObject = (data: any) => {
        let securityQuestionAnswer: any[] = [];

        state.securityQuestion.map((item, index) => {
            const answerIndex = "answer" + (index + 1);

            const answer = {
                UserSecurityQuestionID: item["id"],
                QuestionText: item["question"],
                Answer: data[answerIndex],
            };
            securityQuestionAnswer.push(answer);
            return;
        });

        return securityQuestionAnswer;
    };

    return (
        <React.Fragment>
            <div id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                {tLang("securityQuestionAnswers.titlePage")}
                            </h1>
                        </div>
                    </div>

                    {state.returnToLoginView ? (
                        <div className="row margin-vertical-xl" id="content">
                            <div className="col-xs">
                                <div className="box box-has-shadow box-xs offset-padding">
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon" aria-hidden="true">
                                                <RenderIcons iconName="key" />
                                            </div>
                                            <div className="box-title-text">
                                                <h2 className="box-title">{tLang("securityQuestionAnswers.title")}</h2>
                                            </div>
                                        </div>
                                        <div className="box-description">
                                            <div className="form-row">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Back to Login" });
                                                        props.history.push("/");
                                                    }}
                                                >
                                                    <span className="btn-text">{tLang("securityQuestionAnswers.backToLogin")}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        <div className="form-row row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <p>
                                                    {tLang("securityQuestionAnswers.paragraph2")}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="form-row row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <p>
                                                    {tLang("securityQuestionAnswers.contactInfo.paragraph1")}{" "}
                                                    <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a> {tLang("securityQuestionAnswers.contactInfo.paragraph2")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row margin-vertical-xl" id="content">
                            <div className="col-xs">
                                <div className={state.isLoading ? "box box-has-shadow box-xs offset-padding loading" : "box box-has-shadow box-xs offset-padding"}>
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon" aria-hidden="true">
                                                <RenderIcons iconName="key" />
                                            </div>
                                            <div className="box-title-text">
                                                    <h2 className="box-title">{tLang("securityQuestionAnswers.title")}</h2>
                                            </div>
                                        </div>
                                        <div className="box-description">
                                                <p>{tLang("securityQuestionAnswers.paragraph1")}</p>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        <form id="form-forgot-password" onSubmit={handleSubmit(onSubmit)}>
                                            {state.securityQuestion &&
                                                state.securityQuestion.length > 0 &&
                                                state.securityQuestion.map((item, index) => {
                                                    const answerIndex = "answer" + (index + 1);
                                                    return (
                                                        <div className="form-row" key={index}>
                                                            <div className="form-label">
                                                                <label htmlFor={`question-label-${index + 1}`}>{item["question"]}</label>
                                                            </div>
                                                            <div className="form-input">
                                                                <input
                                                                    type="text"
                                                                    id={`question-label-${index + 1}`}
                                                                    className={errors[answerIndex] ? "status-error inputbox" : "inputbox"}
                                                                    name={answerIndex}
                                                                    ref={register({
                                                                        required: true,
                                                                    })}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                            <div className="margin-bottom-s"></div>

                                            <div className="form-row">
                                                <button type="submit" className="btn-default btn-primary">
                                                        <span className="btn-text">{tLang("securityQuestionAnswers.submitBtn")}</span>
                                                </button>
                                            </div>

                                            {state.errorMessage.length > 0 && (
                                                <div className="form-row row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <span className="required">{state.errorMessage}</span>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="form-row">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Back to Login" });
                                                        props.history.push("/");
                                                    }}
                                                >
                                                        <span className="btn-text">{tLang("securityQuestionAnswers.backToLogin")}</span>
                                                </button>
                                            </div>

                                            {!isLife360PartnerId && (
                                                <>
                                                    <div className="line-divider margin-vertical-l"></div>
                                                    <NeedHelp />
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default SecurityQuestionAnswer;
